import {
    createNewRegolaMenuItemsInitialState,
    createNewSogliaInitialState,
    initialThresholdDetails,
    modifySimsInitialState,
} from "./helper";
import {updateObject} from "../../../shared/utils/updateObject";
import * as actionTypes from "./actionTypes";

const initialState = {
    tableData: [],
    tableLoading: false,
    count: 0,
    createSoglia: createNewSogliaInitialState,
    createRegolaMenuItems: createNewRegolaMenuItemsInitialState,
    thresholdDetails: initialThresholdDetails,
    addOrDeleteSim: modifySimsInitialState,
    addOrDeleteSimLoading: false,
    ruleUpdateLoading: false,
    rulesDeleteLoading: false,
    thresholdsLoading: false
}

const setThresholdData = (state, action) => {
    return updateObject(state, {tableData: action.payload, count: action.count});
}

const setThresholdTableLoading = (state, action) => {
    return updateObject(state, {tableLoading: action.value});
}

const setThresholdDetailsData = (state, action) => {
    return updateObject(state, {thresholdDetails: updateObject(state.thresholdDetails, action.payload)})
}

const setThresholdDetailsLoading = (state, action) => {
    return updateObject(state, {thresholdDetails: updateObject(state.thresholdDetails, {loading: action.value})})
}

const setSimsNewSoglia = (state, action) => {
    return updateObject(state, {createSoglia: updateObject(state.createSoglia, {associateSims: action.payload})})
}

const setLoadingSimsNewSoglia = (state, action) => {
    return updateObject(state, {createSoglia: updateObject(state.createSoglia, {loading: action.payload})})
}

const setUpdateRule = (state, action) => {
    return updateObject(state, {
        thresholdDetails: updateObject(state.thresholdDetails, {
            name: action.payload.name,
            description: action.payload.description,
            suspended: action.payload.suspended
        })
    })
}

const setRuleUpdateLoading = (state, action) => {
    return updateObject(state, {ruleUpdateLoading: action.value});
}

const setRulesDeleteLoading = (state, action) => {
    return updateObject(state, {rulesDeleteLoading: action.value});
}

const setThresholdsLoading = (state, action) => {
    return updateObject(state, {thresholdsLoading: action.value});
}

const setAddOrDeleteSimValue = (state, action) => {
    return updateObject(state, {addOrDeleteSim: updateObject(state.addOrDeleteSim, {[action.name]: action.payload})})
}

const confirmAddOrDeleteSimsLoading = (state, action) => {
    return updateObject(state, {addOrDeleteSimLoading: action.value})
}

const setCreateRegolaMenuItems = (state, action) => {
    return updateObject(state, {createRegolaMenuItems: updateObject(state.createRegolaMenuItems, {[action.name]: action.payload})})
}


const sogliaReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_THRESHOLD_DATA:
            return setThresholdData(state, action);
        case actionTypes.SET_LOADING_THRESHOLD_DATA:
            return setThresholdTableLoading(state, action)
        case actionTypes.FETCH_THRESHOLD_DETAILS:
            return setThresholdDetailsData(state, action)
        case actionTypes.SET_THRESHOLD_DETAILS_LOADING:
            return setThresholdDetailsLoading(state, action)
        case actionTypes.FETCH_SIMS_NEW_SOGLIA:
            return setSimsNewSoglia(state, action)
        case actionTypes.SET_LOADING_SIMS_NEW_SOGLIA:
            return setLoadingSimsNewSoglia(state, action)
        case actionTypes.UPDATE_RULE:
            return setUpdateRule(state, action)
        case actionTypes.UPDATE_RULE_LOADING:
            return setRuleUpdateLoading(state, action)
        case actionTypes.DELETE_RULES_LOADING:
            return setRulesDeleteLoading(state, action)
        case actionTypes.THRESHOLDS_LOADING:
            return setThresholdsLoading(state, action)
        case actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE:
            return setAddOrDeleteSimValue(state, action)
        case actionTypes.SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING:
            return confirmAddOrDeleteSimsLoading(state, action)
        case actionTypes.GET_CREATE_REGOLA_MENU_ITEMS:
            return setCreateRegolaMenuItems(state, action)
        default:
            return state;
    }
};

export default sogliaReducer
